<template>
  <div class="d-flex flex-column">
    <h5>Question additionnelle</h5>
    <p> {{ label }} </p>
    <v-radio
      :action-name="actionName"
      :action-module="actionModule"
      :path="path"
      :custom-default="defaultValue"
      name="negativeRevenue"
      :list="[
        { name: 'Oui', value: true },
        { name: 'Non', value: false },
      ]"
      @validation="validate"
    />
    <div
      v-if="showError"
      class="text-center mb-3"
    >
      <span>
        Impossible de faire une recommandation pour la Responsabilité des Dirigeants. <br>
      </span>
      Veuillez
      <span
        class="btn btn-link p-0 pb-1"
        @click="openIntercom"
      >
        contacter un conseiller
      </span>
      pour obtenir une offre sur mesure&nbsp;!
    </div>
  </div>
</template>
<script>
import { isBoolean, get } from 'lodash-es';
import { mapActions } from 'vuex';

import Radio from '@/components/common/input/Radio.vue';

export default {
  name: 'NegativeRevenue',
  components: {
    'v-radio': Radio,
  },
  props: {
    path: {
      type: String,
      default: 'risk.negativeRevenue',
    },
    label: {
      type: String,
      default: 'A la date de souscription, le souscripteur a-t-il obtenu des résultats nets négatifs ?',
    },
    actionModule: {
      type: String,
      default: 'order',
    },
    actionName: {
      type: String,
      default: 'updatePrice',
    },
  },
  data() {
    return {
      showError: false,
    };
  },
  computed: {
    defaultValue() {
      if (this.current) {
        return get(this.current, this.path);
      }
      return false;
    },
    company() {
      return this.$store.getters['company/get'];
    },
    current() {
      return this.$store.getters[`${this.actionModule}/current`];
    },
    yearDifference() {
      const { registrationDate } = this.company;
      return new Date().getFullYear() - new Date(registrationDate).getFullYear() > 3;
    },
  },
  mounted() {
    this.validate();
  },
  methods: {
    validate() {
      const value = get(this.current, this.path);
      this.showError = value && this.yearDifference;
      this.$emit('validation', isBoolean(value));
    },
    ...mapActions({
      openCalendly: 'ui/openCalendly',
      openIntercom: 'intercom/openMessenger',
    }),
  },
};
</script>
